export const AutoSyncActivitiesDataLayerSymbol = Symbol.for("AutoSyncActivitiesDataLayer");
